function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FormGroup, InputGroup, Label } from "reactstrap";
import _ from 'lodash';
import styled from 'styled-components';
const StyledFormGroup = styled(FormGroup)`
  cursor: not-allowed;
`;
const StyledFormControl = styled.div`
  height: auto !important;
`;

class TmFakeInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(StyledFormGroup, {
        cypress: this.props.cypress
      }, /*#__PURE__*/React.createElement(Label, null, this.props.label || _.startCase(this.props.field)), /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(StyledFormControl, {
        className: 'form-control'
      }, this.props.value)));
    });
  }

}

export default TmFakeInput;